/**
 * Created by Florin David on 21/04/2017.
 */
import { getState } from 'lib/store'

import { ProductFamily } from 'product-family'

/**
 * Get app version
 */
export const getVersion = (): string => getState().version

/**
 * Get generic error
 */
export const getGenericError = (): GenericError | null => getState().error

/**
 * Is update in progress
 *
 */
export const isUpdateInProgress = (): boolean =>
  getState().update.updateInProgress

/**
 * Is update ready
 */
export const isUpdateReady = (): boolean => getState().update.updateReady

export const isOffline = (): boolean => getState().offline

export const getProductFamily = (): ProductFamily => getState().productFamily

export const getQuestion = (): string => getState().question

export const getResponse = (): QueryResponse => getState().response

export const getChatHistory = (): ChatEntry[] => getState().chatHistory

export const getSessionId = (): string | null => getState().sessionId

export const isFetchingResponse = (): boolean => getState().fetchingResponse
